import {ApiErrorResponse, ApiValidationErrorResponse, ErrorResponse} from "@/model/IResponse.ts";

export const DEFAULT_ERROR_TITLES = {
    NETWORK: 'Network Error',
    UNAUTHORIZED: 'Unauthorized',
    FORBIDDEN: 'Access Restricted',
    GENERIC: 'Error',
};

export const DEFAULT_ERROR_MESSAGES = {
    NETWORK: 'A connection error occurred. Please check your internet connection',
    UNAUTHORIZED: 'Your session has expired or you are not authenticated',
    FORBIDDEN: 'You do not have permission to access this resource',
    GENERIC: 'An unexpected error occurred. Please try again later',
};

export interface IErrorData {
    title: string;
    errorMessage: string;
    buttonLabel: string;
    statusCode?: number;
    data?: any;
}

let errorData: IErrorData | null = null;
export const setError = (error: IErrorData) => errorData = error;
export const getError = (): IErrorData => errorData;

export function setValidationError(errorMessage: string){
    const errorData: IErrorData = {
        title: 'Error',
        errorMessage: errorMessage,
        buttonLabel: 'Back',
    };
    
    setError(errorData);
    
    return errorData;
}

export async function handleFetchUnexpectedError(error: ErrorResponse) {
    return BuildFetchErrorData(error.status ?? undefined, '');
}

export async function handleFetchErrorResponse(
    response: Response
){
    const errors = await getFetchErrorMessages(response);
    const errorMsg = (errors && errors.length > 0) ? errors.join(';') : '';
    const statusCode = response?.status ?? undefined;

    return BuildFetchErrorData(statusCode, errorMsg);
}

async function getFetchErrorMessages(apiResponse: Response) {
    let formattedErrors: string[] = [];
    try {
        const r = await apiResponse.json();
        if (r.errors && Array.isArray(r.errors)) {
            const response = r as ApiErrorResponse;
            if (response.errors.length > 0) {
                response.errors.forEach((e: string) => {
                    formattedErrors.push(e);
                });
            }
        } else {
            const response = r as ApiValidationErrorResponse;
            if (response.errors) {
                Object.keys(response.errors).forEach((key) => {
                    const errors = response.errors[key];
                    errors.forEach((e: string) => {
                        formattedErrors.push(e);
                    });
                });
            }
        }
    } catch (_) {
        formattedErrors.push(await apiResponse.text());
    }

    return formattedErrors;
}

function BuildFetchErrorData(statusCode?: number, errorMsg: string = ''){
    let title: string;
    let message: string;
    
    switch (statusCode) {
        case 0:
            title = DEFAULT_ERROR_TITLES.NETWORK
            message = DEFAULT_ERROR_MESSAGES.NETWORK;
            break;
        case 401:
            title = DEFAULT_ERROR_TITLES.UNAUTHORIZED;
            message = errorMsg || DEFAULT_ERROR_MESSAGES.UNAUTHORIZED;
            break;
        case 403:
            title = DEFAULT_ERROR_TITLES.FORBIDDEN;
            message = errorMsg || DEFAULT_ERROR_MESSAGES.FORBIDDEN;
            break;
        case 500:
            title = DEFAULT_ERROR_TITLES.GENERIC;
            message = DEFAULT_ERROR_MESSAGES.GENERIC;
            break;
        default:
            title = DEFAULT_ERROR_TITLES.GENERIC;
            message = errorMsg || DEFAULT_ERROR_MESSAGES.GENERIC;
            break;
    }

    const errorData: IErrorData = {
        title: title,
        errorMessage: message,
        buttonLabel: 'Back',
        statusCode: statusCode
    };

    setError(errorData);
    return errorData;
}







